import { Observable } from 'rxjs/Observable';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { VasBaseObjectStoreFacade } from '../base-object/vas-base-object-store.facade';
import { Qry } from '../query-facade';
import * as actions from './account.actions';
import { Account } from './account.model';
import * as selectors from './account.reducer';

export class AccountStoreFacade extends VasBaseObjectStoreFacade<Account> {

    getAll(): Observable<Array<Account>> {
        return this.select(Qry.getInstance().account.items);
    }

    /**
     * @param {Account} account
     * @deprecated use setActiveById
     */
    setActive(account: Account): void {
        this.dispatch(new actions.SelectAction(account.id));
    }

    setActiveById(id: string): void {
        this.dispatch(new actions.SelectAction(id));
    }

    deActivate(): void {
        this.dispatch(new actions.SelectAction(undefined));
    }

    getActive(): Observable<Account> {
        return this.select(Qry.getInstance().account.selected);
    }

    getPreviousSelectedId(): Observable<string> {
        return this.select(selectors.getSelectedPreviousId);
    }

    getCurrentAndPreviousSelectedId(): Observable<{selected: string, selectedPrevious: string}> {
        return this.select(selectors.getCurrentAndPreviousSelectedId);
    }

    create(account: Account): void {
        this.dispatch(new actions.SubmitAction(account));
    }

    update(account: Account): void {
        this.dispatch(new actions.SubmitAction(account));
    }

    insert(account: Account): void {
        this.dispatch(new actions.SubmitAction(account, {persistable: true, restful: false}));
    }

    remove(account: Account, options?: ActionOptionsArgs): void {

        this.checkCanDelete(account);

        // remove all account objects
        this.appFacade.objects.accessGroup.store.removeByAccount(account, options);
        this.appFacade.objects.contactType.store.removeByAccount(account, options);
        this.appFacade.objects.field.store.removeByAccount(account, options);
        this.appFacade.objects.file.store.removeByAccount(account, options);
        this.appFacade.objects.jobStatus.store.removeByAccount(account, options);
        this.appFacade.objects.jobType.store.removeByAccount(account, options);
        this.appFacade.objects.lookupType.store.removeByAccount(account, options);
        this.appFacade.objects.report.store.removeByAccount(account, options);
        this.appFacade.objects.membership.store.removeByAccount(account, options);

        // remove the account
        this.dispatch(new actions.RemoveAction(account, options));
    }

    canDelete(account: Account): Observable<boolean> {

        return this.appFacade.objects.user.store
            .getActive()
            .map(user => account.owner === user.id)
            .map(result => {
                if (!result) {
                    throw new Error('Only the owner can delete the account');
                }

                return true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.store-facade.ts